import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRatingFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "rating-filled" }), /* @__PURE__ */ _jsx("path", { d: "M16 0c-8.819 0-16 7.181-16 16s7.181 16 16 16c8.819 0 16-7.181 16-16s-7.181-16-16-16zM26.483 14.054l-4.301 4.058 1.011 5.722c0.090 0.474-0.102 0.96-0.499 1.254-0.23 0.166-0.486 0.256-0.768 0.256-0.192 0-0.397-0.051-0.576-0.141l-5.35-2.726-5.35 2.726c-0.435 0.218-0.947 0.179-1.344-0.115-0.384-0.294-0.589-0.768-0.499-1.254l1.011-5.722-4.301-4.058c-0.358-0.333-0.486-0.845-0.346-1.318s0.55-0.806 1.037-0.883l5.978-0.845 2.662-5.222c0.218-0.435 0.653-0.704 1.139-0.704s0.922 0.269 1.139 0.704l2.662 5.222 5.978 0.845c0.486 0.064 0.896 0.41 1.037 0.883s0.038 0.986-0.32 1.318z" })]
});
export default SvgRatingFilled;
